var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"timer"}},[(_vm.display)?_c('span',[_vm._v(_vm._s(_vm._f("asTime")(_vm.time)))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }